import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { CloneDocument } from '@vy/ui-design-system';
import { contractPageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { FC } from 'react';

type CloneContractMenuItemProps = {
  onClick?: () => void;
};
export const CloneContractMenuItem: FC<CloneContractMenuItemProps> = ({ onClick }) => {
  return (
    <MenuItem onClick={onClick} {...getSelectorAttribute(contractPageSelectors.header.cloneContractMenuItem)}>
      <ListItemIcon>
        <CloneDocument />
      </ListItemIcon>
      <ListItemText>Clone contract</ListItemText>
    </MenuItem>
  );
};
